import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createHashHistory } from 'history';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import React, { Component } from 'react';
import entityComposition from '../common/classes/entityComposition';
import reportFunctions from './reportFunctions';
import { getIsPermittedWithAnyOfThesePermissions } from '../common/classes/permissions';
import ReportActionModal from './reportActionModal';
import ReportActionRow from './reportActionRow';
import ReportIssueSummary from './reportIssueSummary';
import ReportsActionHandler from './reportsActionHandler';
const hashHistory = createHashHistory();
const actionKeys = ['Submit', 'Approve', 'Process', 'Reject', 'Delete'];
class ReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableActions: false,
      currentAction: null,
      userCanEditIssues: getIsPermittedWithAnyOfThesePermissions(['issue_admin', 'issue_reviewer'])
    };
    this.getIssuesToApprove = this.getIssuesToApprove.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.handleModalAction = this.handleModalAction.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  /* eslint-disable react/sort-comp, camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const disableActions = this.state.disableActions;
    /* eslint-enable react/sort-comp, camelcase */
    if (disableActions && nextProps.issueStatusList.length > 0) {
      this.setState({
        currentAction: 'Approve',
        disableActions: false
      });
    }
  }
  getIssuesToApprove() {
    // An issue does not need approval if it has a status of reviewed or closed
    const statusIsApproved = ['reviewed', 'closed'];
    const needsApproval = issue => {
      const content = JSON.parse(issue.content);
      if (!content.status) {
        return true;
      }
      const _Object$keys = Object.keys(content.status),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        statusIdentifier = _Object$keys2[0];
      return !statusIsApproved.includes(statusIdentifier);
    };
    const reportActive = this.props.reportActive;
    return (reportActive.issueObjects || []).filter(needsApproval);
  }
  handleAction(currentAction) {
    const userCanEditIssues = this.state.userCanEditIssues;
    const _this$props = this.props,
      issueStatusActions = _this$props.issueStatusActions,
      issueStatusIndexQuery = _this$props.issueStatusIndexQuery,
      issueStatusList = _this$props.issueStatusList;
    const state = {};
    if (currentAction === 'Approve' && userCanEditIssues && !issueStatusList.length) {
      // trigger lookup actions and set set state.currentAction to Approve
      // in UNSAFE_componentWillReceiveProps
      // this.props.issueActions.serverIndex();
      issueStatusActions.serverIndex(issueStatusIndexQuery);

      // tracking lookup actions in progress
      state.disableActions = true;
    } else {
      state.currentAction = currentAction;
    }
    this.setState(state);
  }
  handleModalAction(action) {
    let info = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const _this$props2 = this.props,
      geolocation = _this$props2.geolocation,
      reportActions = _this$props2.reportActions,
      reportActive = _this$props2.reportActive;
    this.setState({
      currentAction: null
    }, () => {
      reportActions.serverSaveStatusUpdates([reportActive], action, info, geolocation);
      hashHistory.replace('/file-cabinet');
    });
  }
  hideModal() {
    this.setState({
      currentAction: null
    });
  }
  render() {
    const currentAction = this.state.currentAction;
    const _this$props3 = this.props,
      children = _this$props3.children,
      reportActive = _this$props3.reportActive,
      reportActions = _this$props3.reportActions,
      user = _this$props3.user;
    const issues = this.getIssuesToApprove();
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ReportsActionHandler, {
      currentAction: currentAction,
      issues: issues,
      onCancel: this.hideModal
    }, /*#__PURE__*/React.createElement(ReportActionModal, {
      actionText: currentAction,
      onAction: this.handleModalAction,
      onHide: this.hideModal
    })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement("h3", null, "Report Actions")), /*#__PURE__*/React.createElement(CardBody, null, actionKeys.map((actionText, index) => /*#__PURE__*/React.createElement(ReportActionRow, {
      actionText: actionText,
      disabled: !reportActive || !Object.keys(reportActive).length || reportFunctions.isActionDisabled(user, actionText.toLowerCase(), [reportActive]),
      onUpload: reportActions.serverUpload,
      index: index,
      key: actionText,
      onAction: this.handleAction
    })))), getIsPermittedWithAnyOfThesePermissions(['issue_show']) ? /*#__PURE__*/React.createElement(ReportIssueSummary, {
      report: reportActive
    }) : undefined), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, children)));
  }
}
ReportContainer.propTypes = {
  issueStatusActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  issueStatusIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool
  }).isRequired,
  issueStatusList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  reportActive: PropTypes.shape({
    statusName: PropTypes.string,
    issueObjects: PropTypes.arrayOf(PropTypes.shape({})),
    reportDocumentObjects: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  reportActions: PropTypes.shape({
    serverSaveStatusUpdates: PropTypes.func,
    serverUpload: PropTypes.func
  }).isRequired,
  children: PropTypes.node.isRequired,
  geolocation: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }).isRequired,
  user: PropTypes.shape({
    permissions: PropTypes.shape({}),
    user_id: PropTypes.string
  }).isRequired
};
export { ReportContainer as TestReportContainer };
export default entityComposition(ReportContainer, [], {
  issueStatusIndexQuery: state => state.issueStatus.indexQuery,
  issueStatusList: state => state.issueStatus.list,
  reportActive: state => state.report.active,
  geolocation: state => state.login.geolocation,
  user: state => state.login.user
}, ['report', 'issueStatus']);